<template>
  <div>
    <h1>Usuário</h1>
    <v-container grid-list-md>
      <v-toolbar color="transparent" flat dense>
        <v-toolbar-items>
          <v-btn to="/users" text><v-icon>view_list</v-icon></v-btn>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn @click="saveBranch" text>Salvar</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-layout column>
        <v-flex md12 mt-3>
          <v-card>
            <v-layout px-4 pt-4 wrap>
              <v-flex md10>
                <v-text-field
                  id="name"
                  name="name"
                  label="Nome"
                  v-model="user.name"
                ></v-text-field>
              </v-flex>
              <v-flex md2>
                <v-checkbox
                  label="Inativo"
                  v-model="user.disabled"
                ></v-checkbox>
              </v-flex>
              <v-flex md12>
                <v-text-field
                  id="email"
                  name="email"
                  label="Email"
                  v-model="user.email"
                ></v-text-field>
              </v-flex>
              <v-flex md12>
                <Combobox
                  label="Unidade"
                  searchEndpoint="/branches"
                  item-text="name"
                  item-value="id"
                  ref="filterBranchPicker"
                  v-model="user.branchId"
                ></Combobox>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>

        <v-flex md12 mt-3>
          <v-card>
            <v-layout px-4 pt-4 wrap>
              <v-flex md6>
                <v-text-field
                  id="username"
                  name="username"
                  label="Login"
                  v-model="user.username"
                ></v-text-field>
              </v-flex>
              <v-flex md6>
                <v-text-field
                  id="password"
                  name="password"
                  label="Senha"
                  v-model="user.password"
                  type="password"
                ></v-text-field>
              </v-flex>
              <v-flex md4>
                <v-checkbox
                  label="Administrador da Unidade"
                  v-model="user.isBranchAdmin"
                ></v-checkbox>
              </v-flex>
              <v-flex md4>
                <v-checkbox
                  label="Administrador Geral"
                  v-model="user.isAdmin"
                ></v-checkbox>
              </v-flex>
              <v-flex md4>
                <v-checkbox
                  label="Financeiro"
                  v-model="user.isAccounting"
                ></v-checkbox>
              </v-flex>
              <v-flex md4>
                <v-checkbox
                  label="Pode Gerenciar Baixas"
                  v-model="user.isFullAccounting"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <OperationStatusCard
      id="loadingStatusCard"
      ref="loadingStatusCard"
      progressMessage="Carregando"
      successMessage="Pronto"
      errorMessage="Falha ao carregar"
    />
    <OperationStatusCard
      id="operationStatusCard"
      ref="operationStatusCard"
      progressMessage="Salvando"
      successMessage="Salvo com sucesso"
      errorMessage="Falha ao salvar"
    />
  </div>
</template>
<script>
import api from "@/api";
import Combobox from "@/components/Shared/Combobox";
import OperationStatusCard from "@/components/Shared/OperationStatusCard";
export default {
  name: "user-form",
  components: {
    Combobox,
    OperationStatusCard
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  data() {
    return {
      user: {}
    };
  },
  methods: {
    saveBranch() {
      this.$refs.operationStatusCard.show();
      var endpoint = this.id ? `/users/${this.id}` : "/users";
      var method = this.id ? "PUT" : "POST";
      api
        .request(method, endpoint, this.user)
        .then(() => {
          this.$refs.operationStatusCard.succeed();
          this.$router.push("/users");
        })
        .catch(error => {
          this.$refs.operationStatusCard.fail(error.response.data);
        });
    }
  },
  mounted() {
    if (this.id) {
      this.$refs.loadingStatusCard.show();
      api
        .request("GET", `/users/${this.id}`)
        .then(response => {
          this.user = response.data.user;
          this.$refs.loadingStatusCard.close();
        })
        .catch(error => {
          this.$refs.loadingStatusCard.fail(error.response.data);
        });
    }
  }
};
</script>
